interface NamedObject {
  name: string;
}

function getFilteredSearchData<T extends NamedObject>(
  value: string[],
  arrayData: T[],
  filterFunction: (arrayData: T[], value: string[]) => T[],
  searchValue?: string,
): T[] {
  let filteredByCategory = arrayData;

  if (value.length) {
    filteredByCategory = filterFunction(arrayData, value);
  }

  if (!searchValue) {
    return filteredByCategory;
  }

  return filteredByCategory.filter(account => {
    const nameValue = account.name;
    if (nameValue !== '') {
      return nameValue.toLowerCase().includes(searchValue!.toLowerCase());
    }
    return false;
  });
}

export { getFilteredSearchData };
